const columns = [
  {
    name: 'Incident id',
    selector: (row) => row?.incident_id,
    sortable: true,
    sortField: 'incident_id',
  },
  {
    name: 'Date',
    selector: (row) => row?.creat_dt,
    sortable: true,
    sortField: 'creat_dt',
  },
  {
    name: 'User Name',
    selector: (row) => row?.user_name_tx,
    sortable: true,
    sortField: 'user_name_tx',
  },
  {
    name: 'Incident Name',
    selector: (row) => row?.incidentname_tx,
    sortable: true,
    sortField: 'incidentname_tx',
  }, 
  {
    name: 'Incident Description',
    selector: (row) => row?.description_tx,
    sortable: true,
    sortField: 'description_tx',
  },
  {
    name: 'Score Change',
    selector: (row) => row?.score_change_total,
    sortable: true,
    sortField: 'score_change_total',
  },
  {
    name: 'Current Score',
    selector: (row) => row?.score_nr,
    sortable: true,
    sortField: 'score_nr',
  },
  {
    name: 'Current Status',
    selector: (row) => row?.ref_status_cd,
    sortable: true,
    sortField: 'ref_status_cd',
  }
];
const mobileColumns = [
  {
    name: 'Incident id',
    selector: (row) => row?.incident_id,
    sortable: true,
    sortField: 'incident_id',
  },
  {
    name: 'Date',
    selector: (row) => row?.creat_dt,
    sortable: true,
    sortField: 'creat_dt',
  }
];

export { columns, mobileColumns };
